import { TextField } from '@material-ui/core'
import React from 'react'
import AutocompleteMaterialUi from '@material-ui/lab/Autocomplete'

const Autocomplete = params => {
  return (
    <AutocompleteMaterialUi
      {...params}
      renderInput={textParams => (
        <TextField
          {...textParams}
          label={params.label}
          helperText={
            params.error
              ? params.error.message
                ? params.error.message
                : params.error.type === 'required'
                ? 'Ce champ est obligatoire'
                : null
              : null
          }
          error={!!params.error}
        />
      )}
    />
  )
}
export default Autocomplete
